import { giphyDarkestGrey, giphyLightGrey } from '@giphy/js-brand'
import { Button } from 'shared/components/buttons'
import { Subheader } from 'shared/components/text-elements'
import LocaleAbTest from 'shared/locale/locale-ab-test'
import styled from 'styled-components'

const Container = styled.div`
    margin: 20px 0 40px;
    width: 100%;
`

const Title = styled(Subheader)`
    color: ${giphyLightGrey};
    font-size: 14px;
    margin-bottom: 6px;
`

const Image = styled.img`
    display: block;
    height: auto;
    margin: -20px -5% -12px;
    pointer-events: none;
    width: 110%;
`

const LearnMore = styled(Button)`
    background: ${giphyDarkestGrey};
    display: block;
`

const GiphyBackdropAd = () => {
    return (
        <Container>
            <Title>
                <LocaleAbTest>Make Your Own Virtual Background</LocaleAbTest>
            </Title>
            <Image src="/static/img/zoomies-small.gif" alt="" />
            <LearnMore as="a" href="/backdrop">
                <LocaleAbTest>Learn More</LocaleAbTest>
            </LearnMore>
        </Container>
    )
}

export default GiphyBackdropAd
